<template>
  <div class="d-flex flex-column flex-root">
    <div class="d-flex flex-column flex-lg-row flex-column-fluid">
      <div class="d-flex flex-column flex-lg-row-fluid py-10 flex-2">
        <div class="d-flex flex-center flex-column flex-column-fluid">
          <div style="height:250px;width:100%;">
            <Logo :zoom="-.5"></Logo>
          </div>
          <div class="w-lg-500px p-10 p-lg-15 mx-auto">
            <div v-if="page == 'login'" class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework manager-login" id="kt_sign_in_form">
              <div class="text-center mb-10">
              </div>
              <div class="fv-row mb-10 fv-plugins-icon-container">
                <label class="form-label fs-6 fw-bolder text-dark">Email / Téléphone</label>
                <input autocomplete="off" class="form-control form-control-lg form-control-solid"
                       name="email" type="text" v-model="username"/>
                <div class="fv-plugins-message-container"></div>
              </div>
              <div class="fv-row mb-10 fv-plugins-icon-container">
                <div class="d-flex flex-stack mb-2">
                  <label class="form-label fw-bolder text-dark fs-6 mb-0">
                    {{ trans('Password') }}
                  </label>
                  <span @click="setPage('reset')" class="link-primary fs-6 fw-bolder cursor-pointer">
                                        {{ trans('Forgotten_?') }}
                                    </span>
                </div>
                <div class="position-relative">
                  <input autocomplete="off" class="form-control form-control-lg form-control-solid password-input"
                         name="password" :type="showPassword ? 'text' : 'password'" v-model="password"/>
                  <span class="password-toggle" @click="showPassword = !showPassword"
                        :title="showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'">
                    <i :class="showPassword ? 'fad fa-eye-slash' : 'fad fa-eye'"></i>
                  </span>
                </div>
                <div class="fv-plugins-message-container"></div>
              </div>
              <!--              <div id="recaptcha" class="g-recaptcha mb-10 d-flex justify-content-center"-->
              <!--                   :data-sitekey="recaptchaKey"></div>-->


              <div class="text-center">
                <button :data-kt-indicator="isLoading ? 'on' : 'off'" @click.prevent="signin()"
                        class="btn btn-lg btn-primary fw-bolder me-3 my-2" id="kt_sign_in_submit" type="submit">
                  <span class="indicator-label">Connexion</span>
                  <span class="indicator-progress">En cours...
                                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
                <router-link :to="{ name: 'partner-login' }" class="btn btn-light-danger btn-lg fw-bolder my-2">
                  <i class="fad fa-sign-in"></i>
                  Portail Partenaire
                </router-link>
              </div>
              <div></div>
            </div>
            <div v-else-if="page == 'reset'" class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
              <div class="text-center mb-10">
                <h1 class="text-dark mb-3">{{ trans('forgot_password_?') }}</h1>
              </div>
              <div class="fv-row mb-10 fv-plugins-icon-container">
                <label class="form-label fs-6 fw-bolder text-dark">Email</label>
                <input autocomplete="off" class="form-control form-control-lg form-control-solid"
                       name="email" type="email" v-model="username"/>
                <div class="fv-plugins-message-container"></div>
              </div>
              <div class="text-center">
                <button @click.prevent="reset = false" class="btn btn-lg btn-secondary fw-bolder me-3 my-2"
                        type="submit">
                  <span class="indicator-label">Annuler</span>
                </button>
                <button :data-kt-indicator="isLoading ? 'on' : 'off'" @click.prevent="confirmReset()"
                        class="btn btn-lg btn-primary fw-bolder me-3 my-2" type="submit">
                  <span class="indicator-label">Reinitialiser</span>
                  <span class="indicator-progress">
                    En cours...
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                </button>
              </div>
              <div></div>
            </div>
            <div v-else-if="page == 'verification'" class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
              <div class="text-center mb-10">
                <h1 class="text-dark mb-3 bg-light-primary px-5 py-3 rounded text-uppercase">{{ username }}</h1>
              </div>
              <div class="fv-row mb-10 fv-plugins-icon-container">
                <label class="form-label fs-6 fw-bolder text-dark">Entrez le code de verification (SMS ou Email)</label>
                <input autocomplete="off" class="form-control form-control-lg form-control-solid" name="email" type="email" v-model="code" @keyup.enter="verify"/>
                <div class="fv-plugins-message-container"></div>
              </div>
              <div class="text-center">
                <button @click.prevent="setPage('login')" class="btn btn-lg btn-secondary fw-bolder me-3 my-2"
                        type="submit">
                  <span class="indicator-label">Annuler</span>
                </button>
                <button :data-kt-indicator="isLoading ? 'on' : 'off'" @click.prevent="verify()" class="btn btn-lg btn-primary fw-bolder me-3 my-2" type="submit">
                  <span class="indicator-label">Connexion</span>
                  <span class="indicator-progress">
                    En cours...
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                </button>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/explicit-module-boundary-types */
import {Component, Vue} from 'vue-property-decorator';
import {api} from "@/services/Api";
import router from "@/router";
import {auth} from "@/services/Auth";
import Logo from "@/components/Logo.vue";
import User from '@/entity/User';
import Swal from 'sweetalert2';
import {helper} from "@/services/Helper";
import Popup from "@/entity/Popup";

@Component({
  components: {Logo}
})
export default class ManagerLogin extends Vue {
  private username = '';
  private password = '';
  private showPassword = false;
  public isLoading = false;
  public page = 'login';
  code = ''
  private error = '';
  public recaptchaKey = api.recaptchaKey
  token = ''

  setPage(value: string) {
    this.code = ''
    this.page = value
  }

  async verify() {
    if (!helper.empty(this.code) && !helper.empty(this.token)) {
      this.$store.commit('loading')
      const res = await api.get(api.auth, 'auth/manager/confirm/' + this.code, {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      });
      this.$store.commit('stopLoading')
      if (res && res.data && res.data.token && res.data.refreshToken) {
        auth.loginData(res.data)
      }
    }
  }

  public async signin(): Promise<void> {
    if (this.isLoading) {
      return
    }
    this.isLoading = true;
    this.error = '';

    if (!this.username.length) {
      this.error = 'Entrez votre nom d\'utilisateur';
      this.isLoading = false;
    }
    if (!this.password.length) {
      this.error = 'Entrez votre mot de passe';
      this.isLoading = false;
    }
    // const w = window as any
    // if (!w.grecaptcha) {
    //   this.error = 'Veuillez patienter un instant';
    //   new Popup('Chargement en cours', 'Veuillez patienter un instant', 'info', 'fad fa-exclamation-triangle')
    //   this.isLoading = false
    //   this.loadCaptcha()
    //   return
    // }
    // const captchaResponse = w.grecaptcha.getResponse()
    const captchaResponse = ''
    // if (helper.empty(captchaResponse)) {
    //   this.error = 'Veuillez cochez la case "Je ne suis pas un robot"';
    //   new Popup('Info', 'Veuillez cochez la case "Je ne suis pas un robot"', 'info', 'fad fa-question-circle')
    //   this.isLoading = false
    //   return
    // }
    if (helper.empty(this.error)) {
      try {
        const host = window.location.host;
        const parts = host.split('.');
        const domainLength = 3;
        // console.log(parts)
        // parts[0] = 'partner'
        if (parts[0] === "partner") {
          this.$router.push({name: 'partner-login'})
          return
        }

        const token = await auth.login(this.username, this.password, captchaResponse);
        if (token) {
          this.token = token
          this.setPage('verification')
        }
      } catch (e) {
        this.isLoading = false;
      }
      this.isLoading = false;
    }
    this.isLoading = false;
    this.$forceUpdate();
  }

  async resetPass(): Promise<void> {
    this.isLoading = true;
    this.$store.commit('load');
    const res = await api.post(api.auth, 'shared/reset/password', {email: this.username});
    this.$store.commit('stopLoad');
    this.isLoading = false;
    this.$forceUpdate();
  }

  requestVerification() {

  }

  async confirmReset() {
    const reset = await Swal.fire({
      title: 'Réinitialisation',
      icon: 'question',
      html: 'Êtes-vous spur de vouloir entamer cette procédure ?',
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
          'Réinitialiser',
      confirmButtonAriaLabel: 'Réinitialiser',
      cancelButtonText:
          'Annuler',
      cancelButtonAriaLabel: 'Annuler'
    })
    if (reset.isConfirmed) {
      const res = await api.get(api.auth, 'api/reset/password/' + this.username)
    }
  }

  logout() {
    auth.logout();
  }

  get isConnected(): boolean {
    return api.isConnected();
  }

  mounted() {
    console.log('suppression de user')

    localStorage.removeItem('user');
    localStorage.removeItem('userRefreshToken');
    localStorage.removeItem('token');
    localStorage.setItem('userType', 'manager')
    // this.loadCaptcha()
    // localStorage.clear();
    // auth.logout();
  }


  attempt = 0

  loadCaptcha() {
    this.attempt++
    if (this.attempt > 5) {
      new Popup('Erreur', 'Veuillez actualiser la page')
      return
    }
    this.$store.state.mainStore.sleep(500)
    const w = window as any
    if (w.grecaptcha) {
      w.grecaptcha.ready(() => {
        const container = document.querySelector("#recaptcha")!
        if (helper.empty(container.innerHTML)) {
          w.grecaptcha.render('recaptcha', {
            'sitekey': api.recaptchaKey,
            'callback': (response: any) => {
            }
          });
        }
      })
    } else {
      this.$store.state.mainStore.sleep(500)
      this.loadCaptcha()
    }
  }
}
</script>
<style scoped>
.password-input {
  padding-right: 3.25rem;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  color: #a1a5b7;
  font-size: 1.15rem;
  line-height: 1;
  cursor: pointer;
}

.password-toggle:hover {
  color: #009ef7;
}
</style>
